
<div v-show="componentToShow" class="advanced-popover-menu px-3 py-2">
  <component :is="activeMenuOption" v-if="componentToShow"  />
</div>
